import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { ApplicationVersionService } from '@core/application-version/services/application-version.service';
import { LoadApplicationVersion } from '@core/application-version/store/actions/application-version.actions';

export interface ApplicationVersionStateModel {
  applicationVersion?: string;
}

@State<ApplicationVersionStateModel>({
  name: 'applicationVersion',
})
@Injectable()
export class ApplicationVersionState {
  private readonly applicationVersionService = inject(ApplicationVersionService);

  @Selector()
  static getApplicationVersion(state: ApplicationVersionStateModel): string | undefined {
    return state.applicationVersion;
  }

  @Action(LoadApplicationVersion)
  loadApplicationVersion(context: StateContext<ApplicationVersionStateModel>): Observable<string> {
    return this.applicationVersionService.getApplicationVersion().pipe(
      tap(applicationVersion => {
        context.patchState({
          applicationVersion,
        });
      })
    );
  }
}
